var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#BDFF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 21.5C31.0034 22.8199 30.6951 24.1219 30.1 25.3C29.3944 26.7117 28.3098 27.8992 26.9674 28.7293C25.6251 29.5594 24.0782 29.9994 22.5 30C21.1801 30.0034 19.8781 29.6951 18.7 29.1L13 31L14.9 25.3C14.3049 24.1219 13.9966 22.8199 14 21.5C14.0006 19.9218 14.4406 18.3748 15.2707 17.0325C16.1008 15.6902 17.2883 14.6056 18.7 13.9C19.8781 13.3049 21.1801 12.9966 22.5 13H23C25.0843 13.115 27.053 13.9948 28.5291 15.4709C30.0052 16.947 30.885 18.9157 31 21V21.5Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f932f198c0e2077e3e0bd87100892974.svg";
export { ForwardRef as ReactComponent };